import { render, staticRenderFns } from "./connecgraduate.vue?vue&type=template&id=03bc24ca&scoped=true"
import script from "./connecgraduate.vue?vue&type=script&lang=js"
export * from "./connecgraduate.vue?vue&type=script&lang=js"
import style0 from "./connecgraduate.vue?vue&type=style&index=0&id=03bc24ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bc24ca",
  null
  
)

export default component.exports